module.exports = __webpack_public_path__ + "img/img-continue.5893c4bd.png";